<template>
  <v-modal
    handle-click-bg
    :full="!screen.breakPoint.tabPort"
    :position="!screen.breakPoint.tabPort ? 'bottom' : 'top'"
    block-scroll
    animation="slide-up"
    v-model="showReflink"
    min-width="50rem"
    fit-content
    v-if="profile.goldShopLogin"
  >
    <template v-slot:activator="{ on }">
      <box clickable @click="on()">
        <div class="dashboard-actions-item d-flex justify-stretch align-center">
          <div><span class="icon-link text--xxx-large"></span></div><div class="ml-2 text--medium">{{ $t('widgets.Dashboard.DashboardActions.goldShopLink') }}</div>
        </div>
      </box>
    </template>

    <template v-slot:header>{{ $t('widgets.Dashboard.DashboardActions.goldShopLink') }}</template>
    <section class="promo-materials__section promo-materials__section--single b-typography mb-2">
      <div class="promo-materials__section-left">
        <h2 class="heading-2 text--normalcase">{{ $t('views.Dashboard.PromoMaterials.referralLink.header1') }}</h2>
      </div>
      <p>{{ $t('views.Dashboard.PromoMaterials.goldshopLogin') }}: <a class="cursor-pointer ref_link_copy text--center" href="javascript:void(0)" v-if="isGoldStatus && goldShopLogin" @click="copyRefLink()">
        <b>{{goldShopLogin}}</b>
      </a></p>
      <div v-html="$t('views.Dashboard.PromoMaterials.goldshopURLText')">
      </div>
    </section>

<!--    <v-input :placeholder="$t('goldshop.Link')" :value="refLink" disabled @click.native="copy()"></v-input>-->

<!--    <template v-slot:footer>-->
<!--      <v-button width="full" @click="copy()">{{ $t('goldshop.Copy') }}</v-button>-->
<!--    </template>-->
  </v-modal>
</template>

<script>
import vModal from '@/ui/modals/vModal'
// import vInput from '@/ui/controls/vInput'
// import vButton from '@/ui/controls/vButton'
import Box from '@/ui/slots/Box'

import profile from '@/mixins/profile'
import screen from '@/mixins/screen'
import reqCountry from '@/mixins/reqCountry'
import isGoldStatus from '@/mixins/isGoldStatus'
import copyToClipboard from '@/mixins/copyToClipboard'

export default {
  data () {
    return {
      showReflink: false
    }
  },

  mixins: [screen, profile, reqCountry, isGoldStatus, copyToClipboard],

  components: {
    vModal,
    // vInput,
    // vButton,
    Box
  },

  methods: {
    copyRefLink () {
      try {
        this.copyToClipboard(this.goldShopLogin)
        this.$notify({
          message: this.$t('views.Dashboard.Documentation.notify.copied'),
          position: 'bottom'
        })
      } catch (e) {
        this.$notify({
          message: this.$t('views.Dashboard.Documentation.notify.notcopied'),
          type: 'error',
          position: 'bottom'
        })
      }
    },
    copy () {
      window.Clipboard = (function (window, document, navigator) {
        let textArea,
          copy

        function isOS () {
          return navigator.userAgent.match(/ipad|iphone/i)
        }

        function createTextArea (text) {
          textArea = document.createElement('textArea')
          textArea.value = text
          document.body.appendChild(textArea)
        }

        function selectText () {
          let range,
            selection

          if (isOS()) {
            range = document.createRange()
            range.selectNodeContents(textArea)
            selection = window.getSelection()
            selection.removeAllRanges()
            selection.addRange(range)
            textArea.setSelectionRange(0, 999999)
          } else {
            textArea.select()
          }
        }

        function copyToClipboard () {
          document.execCommand('copy')
          document.body.removeChild(textArea)
        }

        // eslint-disable-next-line prefer-const
        copy = function (text) {
          createTextArea(text)
          selectText()
          copyToClipboard()
        }

        return {
          copy: copy
        }
      })(window, document, navigator)
      // eslint-disable-next-line no-undef
      Clipboard.copy(this.refLink)

      this.$notify({
        message: this.$i18n.t('goldshop.linkCopied')
      })
    }
  },

  computed: {
    goldShopLogin () {
      return this.profile?.goldShopLogin ?? null
    },
    refLink () {
      if (!this.profile) {
        return ''
      }
      let login = this.profile.goldShopLogin
      login = login.replace(/\./gi, '%2E').replace(/-/gi, '%2D').replace(/_/gi, '%5F')

      return this.reqCountry.RUSSIA ? 'https://join.switips.world/?u=' + login : 'https://myswitplanet.com/?u=' + login
      // return (
      //   window.location.host.startsWith('staging-office.switips.com') || window.location.host.startsWith('office.switips.com') || window.location.host.startsWith('office.swi.tips')
      //     ? 'https://join.switips.club/?u='
      //     : (this.refDomain ? this.refDomain + '/?u=' + login : null)
      // )
    }
  }
}
</script>
